module.exports = __webpack_public_path__ + "static/img/coin_exchange_image_description.fb9d88e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coin_exchange_image_description.png
// module id = CQFq
// module chunks = 0